import React, { useEffect, useRef, useCallback } from "react"
import classNames from "classnames"

import "./Input.css"

const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0

export default function Input({
	onChange,
	onFocus,
	onBlur,
	value,
	hasMessage,
	...rest
}) {
	const ref = useRef(null)

	useEffect(() => {
		ref.current && scrollToBottom(ref.current)
	}, [value])

	const inputClassName = classNames({
		Input: true,
		playback: true,
		over36: value && value.length > 49,
		over98: value && value.length > 128,
	})

	const retainFocus = useCallback(
		(e) => {
			if (isTouchDevice) {
				onBlur && onBlur(e)
				return false
			}

			e.preventDefault()

			ref.current && ref.current.focus()

			onBlur && onBlur(e)
		},
		[onBlur],
	)

	return (
		<textarea
			autoFocus={!hasMessage || window.innerWidth > 640}
			className={inputClassName}
			rows={2}
			cols={84}
			onChange={onChange}
			value={value}
			ref={ref}
			maxLength={236}
			// maxLength={2048}
			{...rest}
			spellCheck="false"
			onFocus={onFocus}
			onBlur={retainFocus}
		/>
	)
}

function scrollToBottom(el) {
	el.scrollTop = el.scrollHeight
}

// function moveCaretToEnd(el) {
// 	if (typeof el.selectionStart == "number") {
// 		el.selectionStart = el.selectionEnd = el.value.length
// 	} else if (typeof el.createTextRange != "undefined") {
// 		el.focus()
// 		var range = el.createTextRange()
// 		range.collapse(false)
// 		range.select()
// 	}
// }
